import React, { useContext } from 'react';
import { GoalIndicationContext } from '../../../../contexts/investment-robot/GoalIndicationContext';
import { Button, ButtonTints } from '../../../general/Button';

export const GoalQuestionBase: React.FC<{
    header?: {
        title?: string;
        description?: string;
    };
    buttons?: {
        next?: {
            id: string;
            label: string;
            onClick: React.MouseEventHandler<HTMLButtonElement>;
            tint?: ButtonTints;
            isDisabled?: boolean;
        };
        previous?: {
            id: string;
            label: string;
            onClick: React.MouseEventHandler<HTMLButtonElement>;
            tint?: ButtonTints;
        };
    };
    pageNumberIndicators?: {
        current: number;
        total: number;
    };
}> = ({ pageNumberIndicators, buttons, children, header }) => {
    const goalIndicationContext = useContext(GoalIndicationContext);
    
    return (
        <div className="flex flex-col items-center py-16 px-4 md:px-8">
            <h1 className="text-bnd-black-3 dark:text-white text-5xl text-center font-black">
                {header?.title}
            </h1>
            {header?.description && (
                <p className="mt-4 text-center text-bnd-black-1 dark:text-gray-300">{header?.description}</p>
            )}
            {pageNumberIndicators && (
                <span className="mt-16 font-semibold">
                    Stap {pageNumberIndicators.current}/{pageNumberIndicators.total}
                </span>
            )}
            <div
                className="flex flex-col items-between justify-center mt-8 p-8 px-8 md:px-12 max-w-7xl w-full bg-white dark:bg-bnd-black-2 dark:border dark:border-gray-500 dark:shadow-none shadow-lg rounded-lg"
                style={{ minHeight: '200px' }}
            >
                {children}
            </div>
            {buttons && (
                <div className="mt-8 grid grid-cols-2 gap-8 ">
                    {buttons.previous !== undefined ? (
                        <Button
                            className=""
                            id={buttons.previous.id}
                            tint={buttons.previous.tint || 'green'}
                            onClick={buttons.previous?.onClick}
                        >
                            {buttons.previous?.label}
                        </Button>
                    ) : (
                        <div></div>
                    )}
                    {buttons.next !== undefined ? (
                        <Button
                            className={`text-white ${
                                buttons.next.tint === 'pink' && !goalIndicationContext.parameters.risk?.selectedId
                                    ? 'cursor-not-allowed opacity-50'
                                    : ''
                            }`}
                            isDisabled={buttons.next.isDisabled || false}
                            id={buttons.next.id}
                            tint={buttons.next.tint || 'green'}
                            onClick={buttons.next?.onClick}
                        >
                            {buttons.next?.label}
                        </Button>
                    ) : (
                        <div></div>
                    )}
                </div>
            )}
        </div>
    );
};
